'use strict';

module.exports = 0xff19;